{
  "cookies": {
    "cookiesProvidersNecessery" : [
      {
        "name": "Benefit Systems S.A.",
        "cookies": [
          {
            "name": "ddc_ad_personalization",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ddc_ad_storage",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ddc_ad_user_data",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ddc_analytics_storage",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ddc_functionality_storage",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ddc_personalization_storage",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ddc_security_storage",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SULUSESSID",
            "expired": "END_OF_SESSION",
            "means": "Utrzymanie sesji",
            "type": "NECESSARY"
          },
          {
            "name": "form_phone",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "cookies",
            "expired": "ONE_YEAR",
            "means": "Zbiera informacje o zgodzie na cookies",
            "type": "NECESSARY"
          },
          {
            "name": "kctd_SMS",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "kctd_EMAIL",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "kctd_AUTHENTICATOR",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "cookie_consent",
            "expired": "ONE_YEAR",
            "means": "Zbiera informacje o zgodzie na cookies, po kliknięciu w przycisk ‘zaakceptuj’ na pasku informującym o cookie",
            "type": "NECESSARY"
          },
          {
            "name": "fe_typo_user",
            "expired": "END_OF_SESSION",
            "means": "Identyfikacja ID sesji, gdy użytkownik jest zalogowany",
            "type": "NECESSARY"
          },
          {
            "name": "storedId",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "relayState",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "isCookiesAccepted",
            "expired": "ONE_YEAR",
            "means": "Informacja o świadomym zamknięciu okna z informacją polityki prywatności przez użytkownika",
            "type": "NECESSARY"
          },
          {
            "name": "APPID",
            "expired": "END_OF_SESSION",
            "means": "ID aplikacji przechowywane na potrzeby działania procesów w kafeterii",
            "type": "NECESSARY"
          },
          {
            "name": "XSRF-TOKEN",
            "expired": "END_OF_SESSION",
            "means": "Zapewnienie bezpieczeństwa",
            "type": "NECESSARY"
          },
          {
            "name": "BENEFIT_SESSIONID",
            "expired": "END_OF_SESSION",
            "means": "Identyfikator sesji",
            "type": "NECESSARY"
          },
          {
            "name": "lang",
            "expired": "END_OF_SESSION",
            "means": "Zapamiętanie preferencji języka przez użytkownika",
            "type": "NECESSARY"
          },
          {
            "name": "AUTH_SESSION_ID",
            "expired": "END_OF_SESSION",
            "means": "Identyfikator bieżącej sesji uwierzytelniania",
            "type": "NECESSARY"
          },
          {
            "name": "AUTH_SESSION_ID_LEGACY",
            "expired": "END_OF_SESSION",
            "means": "Używany do procesu uwierzytelniania",
            "type": "NECESSARY"
          },
          {
            "name": "KC_RESTART",
            "expired": "END_OF_SESSION",
            "means": "Używany do procesu uwierzytelniania",
            "type": "NECESSARY"
          },
          {
            "name": "KEYCLOAK_LOCALE",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "rc::a",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "ASP.NET_SessionId",
            "expired": "END_OF_SESSION",
            "means": "Rejestrowanie obecnej sesji użytkownika",
            "type": "NECESSARY"
          },
          {
            "name": "cookiepolicyinfo",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "MT_PHPSESSID",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "cookie",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "PHPSESSID",
            "expired": "END_OF_SESSION",
            "means": "Utrzymanie sesji i identyfikowanie sesji klienta",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Creative CDN",
        "cookies": [
          {
            "name": "receive-cookie-deprecation",
            "expired": "SEVEN_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "receive-cookie-deprecation",
            "expired": "SIX_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "receive-cookie-deprecation",
            "expired": "EIGHT_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "receive-cookie-deprecation",
            "expired": "SIX_MONTHS",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Didomi",
        "cookies": [
          {
            "name": "didomi_token",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "euconsent-v2",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Freshdesk",
        "cookies": [
          {
            "name": "_x_w",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "eachSlice",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Google Ireland Ltd                                   ",
        "cookies": [
          {
            "name": "rc::c",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-1PAPISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-1PSID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-1PSIDCC",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-1PSIDTS",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-3PAPISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-3PSID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-3PSIDCC",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-3PSIDTS",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "__Secure-ENID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "AEC",
            "expired": "FIVE_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "HSID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SAPISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SAPISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SAPISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SEARCH_SAMESITE",
            "expired": "FIVE_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SIDCC",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SOCS",
            "expired": "FIVE_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SSID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "SAPISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Inteliwise S.A.",
        "cookies": [
          {
            "name": "focus-id-",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "iw-ichr-cokie-Inteliwise-SaasModule_",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Intercom, Inc.",
        "cookies": [
          {
            "name": "intercom-id-[app_id]",
            "expired": "NINE_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "intercom-session-[app_id]",
            "expired": "SEVEN_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "intercom-device-id-[app_id]",
            "expired": "NINE_MONTHS",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Keycloak",
        "cookies": [
          {
            "name": "KEYCLOAK_3P_COOKIE_SAMESITE",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Meta Platforms Ireland Limited",
        "cookies": [
          {
            "name": "datr",
            "expired": "TEN_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "presence",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "sb",
            "expired": "ELEVEN_MONTHS",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "usida",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          },
          {
            "name": "xs",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "PerfectGym",
        "cookies": [
          {
            "name": "ClientPortal.Embed",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Prowly Journal",
        "cookies": [
          {
            "name": "prowly-journal-session",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": "Vimeo.com, Inc.",
        "cookies": [
          {
            "name": "vuid",
            "expired": "THIRTEEN_MONTHS",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      },
      {
        "name": ".vimeo.com",
        "cookies": [
          {
            "name": "__cf_bm",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "NECESSARY"
          }
        ]
      }
    ],
    "cookiesProvidersMarketing" : [
      {
        "name": "Benhauer sp. z o.o. ",
        "cookies": [
          {
            "name": "smvr",
            "expired": "THREE_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "smuuid",
            "expired": "THREE_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "smcfds",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "smclient",
            "expired": "THREE_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "smwp",
            "expired": "THREE_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "smuuid",
            "expired": "TEN_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_smvs",
            "expired": "ONE_DAY",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Creative CDN ",
        "cookies": [
          {
            "name": "g",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Criteo S.A.",
        "cookies": [
          {
            "name": "cto_bundle",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": ".ctnsnet.com",
        "cookies": [
          {
            "name": "cid_*",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": ".doubleclick.net",
        "cookies": [
          {
            "name": "test_cookie",
            "expired": "FIFTEEN_MINUTES",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "IDE",
            "expired": "ONE_YEAR_24_DAYS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Floodlight",
        "cookies": [
          {
            "name": "HSID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "DSID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "SIDCC",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "SAPISID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "ANID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "1P_JAR",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "SSID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "NID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "SID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "APISID",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Google Ireland Ltd",
        "cookies": [
          {
            "name": "_gcl_au",
            "expired": "THREE_MONTHS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "APISID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "CONSENT",
            "expired": "FIVE_MONTHS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "IDE",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "NID",
            "expired": "FIVE_MONTHS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "NID",
            "expired": "SIX_MONTHS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Hot Jar Ltd.",
        "cookies": [
          {
            "name": "_hjAbsoluteSessionInProgress",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_hjFirstSeen",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_hjSessionUser_*",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_hjSession_*",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "LinkedIn Ireland",
        "cookies": [
          {
            "name": "UserMatchHistory",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "lang",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "lidc",
            "expired": "ONE_DAY",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "AnalyticsSyncHistory",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "li_gc",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "bcookie",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "bscookie",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Meta Platforms Ireland Limited",
        "cookies": [
          {
            "name": "_fbp",
            "expired": "NINETY_DAYS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "c_user",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "dpr",
            "expired": "SEVEN_DAYS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "fr",
            "expired": "SIXTY_DAYS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "oo",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "fr",
            "expired": "NINETY_DAYS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Microsoft",
        "cookies": [
          {
            "name": "_uetsid",
            "expired": "ONE_DAY",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_uetvid",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": ".revhunter.tech",
        "cookies": [
          {
            "name": "adf",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "history",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "RTB House",
        "cookies": [
          {
            "name": "__rtbh.uid",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Synerise S.A. ",
        "cookies": [
          {
            "name": "_snrs_sb",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_snrs_sa",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_snrs_*",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_snrs_uuid",
            "expired": "FOUR_HUNDRED_DAYS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_snrs_puuid",
            "expired": "FOUR_HUNDRED_DAYS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_snrs_p",
            "expired": "FOUR_HUNDRED_DAYS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "TikTok",
        "cookies": [
          {
            "name": "_tt_enable_cookie",
            "expired": "THIRTEEN_MONTHS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "_ttp",
            "expired": "THIRTEEN_MONTHS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      },
      {
        "name": "Youtube ",
        "cookies": [
          {
            "name": "YSC",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "VISITOR_INFO1_LIVE",
            "expired": "FIVE_MONTHS_27_DAYS",
            "means": "",
            "type": "MARKETING"
          },
          {
            "name": "CONSENT",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "MARKETING"
          }
        ]
      }
    ],
    "cookiesProvidersAnalytics" : [
      {
        "name": "Benefit Systems S.A. ",
        "cookies": [
          {
            "name": "catAccCookies",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "MyBenefitCookies",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjFirstSeen",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjSession_",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjSessionUser_",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_ga",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_gid",
            "expired": "TWENTY_FOUR_HOURS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "PastVisitor",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          }
        ]
      },
      {
        "name": "Didomi",
        "cookies": [
          {
            "name": "didomi_token",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "euconsent-v2",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmt",
            "expired": "TEN_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmz",
            "expired": "SIX_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utma",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmc",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmb",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "ahoy_visitor",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "ahoy_visit",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          }
        ]
      },
      {
        "name": "Google Ireland Ltd",
        "cookies": [
          {
            "name": "_dc_gtm_UA-*",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_gat",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_gid",
            "expired": "TWENTY_FOUR_HOURS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_ga_*",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_gat_UA-*",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_ga_",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "gat_",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmz",
            "expired": "SIX_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmc",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utma",
            "expired": "TWO_YEARS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmb",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "__utmt",
            "expired": "TEN_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_gat_gtag_UA_151102250_1",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_gat_UA*",
            "expired": "ONE_MINUTE",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "ar_debug",
            "expired": "THIRTY_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "hjIncludedInPageviewSample",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_BEAMER_FIRST_VISIT_*",
            "expired": "NINETY_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_BEAMER_LAST_UPDATE_*",
            "expired": "NINETY_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_BEAMER_USER_ID_*",
            "expired": "NINETY_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hp2_id.*",
            "expired": "NINE_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "userty.core.p.*",
            "expired": "NINE_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjSessionUser_*",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjAbsoluteSessionInProgress",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjClosedSurveyInvites",
            "expired": "YEAR_ON_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjDonePolls",
            "expired": "YEAR_ON_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjMinimizedPolls",
            "expired": "YEAR_ON_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjShownFeedbackMessage",
            "expired": "YEAR_ON_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjSessionTooLarge",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjIncludedInSessionSample",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjSessionRejected",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjid",
            "expired": "YEAR_ON_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjRecordingLastActivity",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjTLDTest",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjUserAttributesHash",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjCachedUserAttributes",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjLocalStorageTest",
            "expired": "ONE_HUNDRED_MS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjIncludedInPageviewSample",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjViewportId",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjRecordingEnabled",
            "expired": "END_OF_SESSION",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjFirstSeen",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_hjSession_*",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "hjSession",
            "expired": "THIRTY_MINUTES",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "hjSessionUser",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "wd",
            "expired": "SEVEN_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_clck",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "_clsk",
            "expired": "ONE_DAY",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "CLID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "ANONCHK",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "MR",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "MUID",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "SM",
            "expired": "ONE_YEAR",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "ts",
            "expired": "SIXTY_DAYS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "u",
            "expired": "FIVE_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          },
          {
            "name": "uid",
            "expired": "ELEVEN_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          }
        ]
      },
      {
        "name": ".adform.net",
        "cookies": [
          {
            "name": "uid",
            "expired": "TWO_MONTHS",
            "means": "",
            "type": "ANALYTICS"
          }
        ]
      },
      {
        "name": ".ctnsnet.com",
        "cookies": [
          {
            "name": "cid",
            "expired": "ONE_MONTH",
            "means": "",
            "type": "ANALYTICS"
          }
        ]
      }
    ],
    "terms": {
      "cookies": {
        "header": "Table of contents",
        "subheader": "If you want to go to the selected section, click on the link below:",
        "list": [
          {
            "heading": "",
            "link": "about",
            "content": "Websites and applications of Benefit Systems S.A (<b>“Benefit Systems\"</b> or <b>“we”</b>) use cookies and similar technologies.\n <br>\n <br>\n Below you will find information about cookies and similar technologies that we use, as well as additional information on how our websites and applications work, including information about Local Storage, push messages and your location.\n "
          },
          {
            "heading": "What are cookies?",
            "link": "cookies",
            "content": "<p>Cookies are text files that are stored on your device (e.g. a computer, laptop, or smartphone) as you browse the internet. <br><br> When you revisit websites of Benefit Systems, your browser sends cookies back to the website (or to its server, strictly speaking). In this way we can obtain information on user activity, for example, we can recognise when the user visits us again.<br><br>Cookies have a stated expiry date after which they become inactive. Our websites and applications also use other similar technologies such as pixels, plugins, tags, and web beacons. We will refer to these technologies collectively as \"<b>cookies</b>\".<br><br>We use cookies e.g. to obtain and process information about the browser and its version, operating system, URL of the previously visited page, IP address, time of the server request, user ID, language, searches on the website, products added to the basket, authentication data, data on the content viewed, and data on other activities carried out on the website or in the application. We combine your user ID with other data provided by you (such as email address or telephone number)."
          },
          {
            "heading": "What cookies do we use?",
            "link": "type-of-cookie",
            "content": "<p>The list of cookies used in our websites and applications, including information on their origin, purpose, retention, supplier and our partner (“<b>Partner</b>”) can be found below, together with some additional important information.</p>"
          },
          {
            "heading": "Why do we use cookies? ",
            "link": "why-cookies",
            "content": "<p>We categorise and use cookies as described below:</p> <ol> <li><p><b>Necessary cookies</b> – these cookies are necessary for the functioning of websites and applications. Thanks to the assigned ID and collected data, they allow you to use resources and functionalities of websites and applications (e.g. they remember you as a logged-in user, ensure proper functioning of the website’s content), and also increase efficiency, allow you to find the information you need faster, are used to remember your settings regarding cookies and support the security of websites, applications and services provided. Without these cookies, using our websites will not be possible.</p></li></ol>"
          },
          {
            "onlySlot": true,
            "heading": "",
            "link": "",
            "content": ""
          },
          {
            "heading": "",
            "link": "",
            "content": " <p>Cookies, apart from the ones that are necessary for the functioning of our websites and applications, are used based on your consent. Refusing your consent to cookies other than the necessary ones will not prevent you from using our websites but can negatively affect your experience (e.g. advertisements will not be tailored to the user preferences). <br><br> Among the cookies other than the necessary ones we distinguish:</p> <ol start=\"2\"> <li class=\"analitic-list-element-1\"><p><b>Marketing cookies</b> – these cookies collect information about the activity of users on our websites or applications. This information is used for profiling for marketing purposes, presenting personalized content and offers tailored to your potential interests or profile, conducting advertising campaigns, including retargeting. With the use of these cookies information is collected, e.g. that you have visited our websites and what activities you have performed on our websites. They allow us and our Partners to reach specific groups of users with our marketing, users who have previously visited our websites or applications, and to monitor the implementation of advertising campaigns. Their use requires your consent.</p></li></ol>"
          },
          {
            "onlySlot": true,
            "heading": "",
            "link": "",
            "content": ""
          },
          {
            "heading": "",
            "link": "",
            "content": "<ol><li class=\"analitic-list-element-2\"><p><b>Analytics cookies</b> – these cookies are used to collect analytical and statistical information, e.g. counting visits on websites or applications, examining the duration of visits, traffic sources and determining what functionalities or parts of websites or applications are most often used or visited. Thanks to this information, we learn which websites or functionalities are popular, what is the efficiency of websites and applications, and what needs improvement. This information allows us to plan the development of websites and applications. Their use requires your consent.</li> </ol>"
          },
          {
            "onlySlot": true,
            "heading": "",
            "link": "",
            "content": ""
          },
          {
            "heading": "",
            "link": "",
            "content": "<p>Moreover, we divide cookies as follows:</p> <ol> <li><p><b>Session cookies</b> –files which are temporary (e.g. they last until the browser is closed). They are necessary for the website to function properly.</p></li> <li><p><b>Permanent cookies</b> – files which retain website settings and improve the user experience (e.g, by remembering what has been entered into a form, user location, information on resolution and font size and type).</p></li> </ol>"
          },
          {
            "heading": "Do we use third party cookies?",
            "link": "other-cookies",
            "content": "<p>Yes, when you use our websites or applications, you may receive cookies from the third parties that cooperate with us, that is our Partners. We use those cookies mainly for analytical and marketing purposes. </p> <p>We use the following tools provided by Partners, related to the use of cookies and identifiers: </p> <ol><li><p><b>Google Tag Manager</b> – a tool for managing tags placed on websites. The tool itself does not use cookies, but helps manage tags that may lead to the storage of cookies</p></li> </ol> <p><b>Analytical tools</b></p> <ol> <li><p><b>Google Analytics</b> – a tool that collects analytical data, i.e. counts visits to websites or applications, measures the duration of visits and determines which functionalities or parts of websites or applications are used or visited most often. Google Analytics uses cookies and creates pseudonymised user profiles. The IP addresses obtained by the tool are anonymized so that they cannot be assigned to a specific user.</p> <p>To block the collection of information about your activity by Google Analytics, go to: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://tools.google.com/dlpage/gaoptout\">tools.google.com/dlpage/gaoptout</a></p></li> <li><p><b>Hotjar</b> – a tool that collects analytical data about the behaviour and preferences of users on our websites, e.g. time spent on specific pages or the most frequently clicked items. Hotjar stores this information in a pseudonymised user profile. Neither Hotjar nor we will use this information to identify individual users or to match it with further data on an individual user. </p> <p>To block the collection of information about your activity by Hotjar, go to: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://help.hotjar.com/hc/en-us/articles/360002735873-How-to-Stop-Hotjar-From-Collecting-your-Data\">help.hotjar.com/hc/en-us/articles/360002735873-How-to-Stop-Hotjar-From-Collecting-your-Data</a></p></li> </ol> <p><b>Marketing Tools</b></p> <ol> <li><p><b>Synerise, SALESmanago</b> – tools supporting the automation of marketing and sales processes, including the processing of marketing and sales data and their complex analytics in the multi-channel model – i.e. in a model that allows the user to be reached via various channels (such as websites, push notifications, SMSs, MMSs, -mail, chat, telephone...) and various devices (such as computers, smartphones, tablets, telephones...). </p></li> <li><p><b>Google Ads</b> – Google’s advertising platform for running text, image and video ads as well as displaying sponsored links in the search results of the Google search engine and on cooperating websites under the Google AdSense programme. </p></li> <li><p><b>Google Marketing Platform</b> – a platform that allows us to use many Google marketing tools in order to provide users with tailored ads, avoid displaying ads that the user has already seen, optimise campaigns and monitor their progress.</p><p>To block the Google advertising tools, use the information available at: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.google.com/settings/ads/plugin\">www.google.com/settings/ads/plugin</a></p></li> <li><p><b>Facebook (Meta) Ads Manager</b> – Facebook’s advertising system for creating, purchasing and managing ads within the Facebook, Instagram, and Messenger social networks, and Facebook’s Audience Network. We use the Facebook Pixel on our websites. It allows us to track activity on our website, and on this basis show you ads tailored to your needs or display ads to other Facebook users whose profile is similar to yours.</p><p>Facebook users can manage their ad preferences at <a href=\"https://www.facebook.com/ads/preferences\" target=\"_blank\">www.facebook.com/ads/preferences</a>(in addition, in Ads settings, you can also disable the possibility of personalising ads Facebook ads that use data provided by us). </p><p>Other users can manage these preferences at: <a href=\"https://www.facebook.com/settings/ads/\" target=\"_blank\">www.facebook.com/settings/ads</a>  or at: <a href=\"https://www.youronlinechoices.com/pl/twojewybory\" target=\"_blank\">www.youronlinechoices.com/pl/twojewybory</a>. </p><p>In addition to the above tools, our websites and applications use cookies from other Partners. A full list of those Partners can be found above. You can block targeted ads from “About Ads” providers at <a href=\"https://www.aboutads.info/choices\" target=\"_blank\">www.aboutads.info/choices</a> or „European Interactive Digital Advertising Alliance” providers at <a href=\"https://www.youronlinechoices.com/pl/twojewybory\" target=\"_blank\">www.youronlinechoices.com/pl/twojewybory</a>. The block should be set for each browser. It will remain in effect until you remove cookies from your browser. </p>"
          },
          {
            "heading": "How to manage cookies?",
            "link": "menage-cookies",
            "content": "<p>Except for the cookies necessary for the website operation, we only use cookies with the user’s consent. When you open our website, we will ask you to make choices regarding these cookies.You can manage your choices based on the type of cookies, as well as the Partner they come from. You can change the choices you have made at any time by clicking <b>Cookie preferences</b> at the bottom of the website.<br>Apart from the above, you can go to the browser settings to disable cookies, delete any cookies already stored or modify the option of storing them on your device. Remember that changing your browser settings by disabling or limiting the possibility of storing cookies may limit the functionality of websites or applications.<br><br>In the menu bar of each web browser, go to the “Help” section to find information on how to manage cookie settings. Below you will find details about how to manage cookie settings in the most popular browsers:<ol><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09\">Edge</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.google.com/chrome/answer/95647?hl=pl\">Chrome</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.apple.com/pl-pl/guide/safari/sfri11471/mac\">Safari</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectlocale=en-US&redirectslug=enable-and-disable-cookies-website-preferences\">Firefox</a></li></ol>"
          },
          {
            "heading": "Additional important information concerning Website operation:",
            "link": "storage",
            "content": "<p><b>Local Storage</b></p><p>Our websites also use a technology called Local Storage. Local Storage is a location where information is stored in your browser. Contrary to cookies, the data stored in Local Storage are not sent by the browser each time the website is visited. Here we will save your searches so that when you re-enter them they will appear in prompts and thus your search will be faster.</p><p><b> →  How to delete data from Local Storage?</b></p><p>Local Storage stores data for the long term, until you restore the default settings or manually delete the data from the browser’s cache. You can find the instructions above or in the “Help” section of the menu bar of any web browser. </p><p><b>Push Notifications</b></p><p>Push notifications are short messages which appear on your device’s screen.</p><p>For us, they are a marketing tool which supports our communication with you. For you, they are a source of information on our services, including news, facilities and seasonal activities, campaigns, competitions or events. </p><p>We need your consent to send you push notifications. When you enter the website or application, we will ask you whether you want to receive notifications from us. If you consent, we will be able to send you the content you might find interesting even when you leave our website or application. </p><p><b> →  How to disable push notifications?</b></p><p>You opt out of receiving notifications at any time by changing the settings of your browser or application. Below you will find details about how to disable notifications in the most popular browsers:</p><ol><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.microsoft.com/pl-pl/microsoft-edge/blokowanie-wyskakuj%C4%85cych-okienek-w-przegl%C4%85darce-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5\">Edge</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.google.com/chrome/answer/3220216?hl=pl&co=GENIE.Platform%3DDesktop\">Chrome</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.apple.com/pl-pl/guide/safari/sfri40734/mac\">Safari</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.mozilla.org/pl/kb/powiadomienia-web-push-firefox\">Firefox</a></li></ol><p><b>Location</b></p><p>You can consent to the use of location data in your browser, application or device settings. We use this feature to provide you with information such as the location of the nearest fitness club or to display personalised ads and offers based on your location.</b></p><p><b> →  How to turn off the location sharing?</b></p><p>You can turn off location sharing using the application, device or browser settings:</p><ol><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.microsoft.com/pl-pl/microsoft-edge/lokalizacja-i-prywatno%C5%9B%C4%87-w-przegl%C4%85darce-microsoft-edge-31b5d154-0b1b-90ef-e389-7c7d4ffe7b04\">Edge</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.google.com/accounts/answer/3467281?hl=pl#location_accuracy\">Chrome</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.apple.com/pl-pl/HT5403\">Safari</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.mozilla.org/pl/kb/czy-firefox-udostepnia-moje-polozenie-stronom?redirectlocale=en-US&redirectslug=does-firefox-share-my-location-web-sites\">Firefox</a></li></ol><p>If you have any questions on cookies used in our websites and applications or if you wish to exercise your data subject rights, you can contact us in a manner referred to here <a href=\"https://www.benefitsystems.pl/en/privacy-policy\">https://www.benefitsystems.pl/en/privacy-policy</a>.</p>"
          }
        ]
      }    
    }
  },
  "privacy": {
    "header": "Table of contents",
    "subheader": "Click below to navigate to the selected section.",
    "list": [
      {
        "heading": "General information",
        "link": "about",
        "content": "We treat personal data protection at Benefit Systems S.A. (<b>\"Benefit Systems\"</b>, <b>\"we\"</b>) very seriously. \n We exercise due diligence to ensure that your personal data are processed in accordance with the applicable provisions of both \n Polish and European Union law, including the Regulation (EU) of the European Parliament and of the Council of 27 April 2016 on the \n protection of individuals with regard to the processing of personal data and on the free movement of such data, and repealing \n Directive 95/46/EC (<b>“GDPR”</b>).\n Below you will find information on how we process your data, in particular the legal basis for processing, methods of collecting and \n using your personal data and your rights in connection with the processing of your personal data."
      },
      {
        "heading": "Who is the Controller of your personal data and what does it mean",
        "link": "admin",
        "content": "The Controller of your personal data is Benefit Systems (Benefit Systems S.A. with its registered office in Warsaw, at \n Plac Europejski 2, 00-844 Warszawa).\n This means that Benefit Systems makes decisions about the purposes and methods of processing your personal data, i.e. the manner in \n which they will be used."
      },
      {
        "heading": "How to contact us",
        "link": "contact",
        "content": "<b>You can contact us in any of the following ways:</b>\n <br>\n <ol>\n <li><span>Using the <a href=\"https://www.benefitsystems.pl/pomoc-i-obsluga/rodo/\">contact form</a></span></li>\n <li><span>Via e-mail to: <a href=\"mailto:daneosobowe&#64;benefitsystems.pl\">daneosobowe&#64;benefitsystems.pl</a></span></li>\n <li><span>Via the e-mail address dedicated to customers of our fitness clubs: <a href=\"mailto:daneosobowe&#64;fitness.benefitsystems.pl\">\n daneosobowe&#64;fitness.benefitsystems.pl</a></span></li>\n <li><span>By post to: Benefit Systems S.A. Pl. Europejski 2, 00-844 Warszawa, in an envelope marked “Personal data”.</span></li>\n </ol>\n <b>Contact with the data protection officer</b>\n <br>\n <br>\n We have designated a personal data officer, who can be contacted in any matters concerning the processing of your personal data. \n You can do this by e-mail to: <a href=\"mailto:iod&#64;benefitsystems.pl\">iod&#64;benefitsystems.pl</a> \n Benefit Systems S.A. Pl. Europejski 2, 00-844 Warszawa, in an envelope marked “IOD”."
      },
      {
        "heading": "What personal data do we process. Where we collect them from",
        "link": "personal-data-1",
        "content": "To be able to do our business, we need to process personal data. <b>Personal data</b> are any information relating to an identified \n or identifiable natural person (e.g. first name and surname, e-mail address, MultiSport card number, IP address).\n <br>\n <br>\n As a rule, you provide us with your data on your own, e.g. when contacting us or using our services.The types of personal data we \n process depend on your relationship with us (whether you are a customer, website user, MultiSport card user, or partner).\n <br>\n <br>\n When you use our <b>websites or applications</b>, we process the data that you have provided in the registration form and in the account, \n data about your activity on the website or application (e.g. interaction with content, etc.) and data about your device \n (i.e. IP address, data collected by means of cookies or other similar technologies, browser data, IDs). To find out more about cookies, \n go to our <a href=\"/en/cookies-policy\">“Cookies Policy”</a>.\n <br>\n <br>\n When you join the <b>MultiSport Programme or the MultiLife Programme, use our Cafeteria, sign a Fitness Club subscription or use our other \n services</b> (such as BenefitLunch, MultiBilet, or MultiTeatr), we process your data, such as identification data, contact details and data \n relating to your use of our services (including the services of our affiliated entities and providers of additional services offered in \n connection with the MultiSport Programme, MultiLife, our Cafeteria, a membership card of our Fitness Club or our other services). \n We receive the data directly from you, e.g. through the registration form or when signing the contract at the Fitness Club of your \n choice or on the Club's website. We may also receive your data from the entity that has enabled you to use the MultiSport Programme, \n MultiLife Programme, Cafeteria or our other services, and from providers of additional services and benefits.\n <br>\n <br>\n When we have a <b>business relationship</b> with you, we process your data, such as your identification data, contact data, data relating to \n your function, data on the cooperation, orders and settlements. If you are a party to a contract with us, we have received the data \n directly from you. If you are a representative or a contact person of an entity that is a party to a contract signed with Benefit \n Systems, we have received the data from the entity that is a party to the contract. We could also receive data from an intermediary \n that helped us establish the cooperation with you or an entity for which you are a representative or contact person.\n "
      },
      {
        "heading": "How we process your personal data",
        "link": "personal-data-2",
        "content": "The manner in which your personal data are processed depends on the relationship you have with Benefit Systems. \n Below you will find information on the purposes for which we usually process personal data.\n <br>\n <br>\n If you cannot find below any description that would fit our relationship, and you would like to get additional information about how we\n process your data, please contact us. You can find contact details above in section <a href=\"#contact\">How to contact us</a> powyżej.\n <br>\n <br>\n It may happen that due to the specific nature of your use of our services, we might process your personal data in a manner other than \n that indicated below. In that case, we will inform you of such processing before it starts.\n <br>\n <br>\n <table>\n <tbody>\n <tr>\n <th>\n Purposes of the processing:\n </th>\n <th>\n Legal basis:\n </th>\n </tr>\n <tr>\n <td>\n Provision of services as part of our websites or mobile applications\n </td>\n <td>\n Performance of a contract for provision of services by electronic means in accordance with a terms of service (Article 6(1)(b) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Administering the infrastructure and ensuring security of the infrastructure and the services provided\n </td>\n <td>\n Our legitimate interest connected with administering and ensuring security of infrastructure and services (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Facilitating the use, keeping statistics, as well as improving and developing our services, including websites and applications\n </td>\n <td>\n Our legitimate interest connected with adaptation, improvement and development of our services (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Providing services or tailored marketing content that uses special categories of data (e.g. health data)\n </td>\n <td>\n Your explicit consent (Article 9(2)(a) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Showing you, in the search engine or in the application, facilities that are closest to your location\n </td>\n <td>\n Our legitimate interest connected with helping you find a facility, subject to your consent for our access to location data \n (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Conducting a competition or lottery, including selecting a winner, handing over prizes, publishing the winner's personal data\n </td>\n <td>\n Our legitimate interest connected with organisation of the competition or lottery (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Running our websites in social media\n </td>\n <td>\n Our legitimate interest connected with promoting our products and services (including those prepared together with counterparties), \n as well as products and services of third parties, including companies from the Benefit Systems Group, and keeping statistics on \n the use of our websites (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Provision of services related to the participation in the MultiSport or MultiLife Programme\n </td>\n <td>\n Your consent (Article 6(1)(a) of the GDPR)<br>\n Also given through your explicit application to the Programme directly to us or through the employer.</td>\n </tr>\n <tr>\n <td>\n Provision of services related to the use of the Cafeteria and other services (such as BenefitLunch, MultiBilet, MultiTeatr)\n </td>\n <td>\n Performance of the contract between you and Benefit Systems (Article 6(1)(b) of the GDPR);\n Our legitimate interest connected with the provision and settlement of services (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Provision of services related to your use of our Fitness Club or other services when you enter into a contract with us\n </td>\n <td>\n Performing the contract between you and Benefit Systems, e.g. the contract for the provision of services by our Club (Article 6(1)(b) of the GDPR);\n Your consent relating to the processing of your image or fingerprint to identify you when entering our Club (Article 6(1)(a), \n Article 9(2)(a) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Marketing\n </td>\n <td>\n Our legitimate interest (Article 6(1)(f) of the GDPR) connected with promoting our products and services, as well as products \n and services of third parties, including companies from the Benefit Systems Group\n </td>\n </tr>\n <tr>\n <td>\n Displaying advertisements or offers to you that may be tailored to your interests, activity on websites and applications, or your location\n </td>\n <td>\n Our legitimate interest (Article 6(1)(f) of the GDPR) consisting in presenting you with advertisements and offers (tailored or not) \n in relation to the contract between us and our cooperation and with your consent for the use of cookies and similar technologies or \n information about your location for marketing purposes\n </td>\n </tr>\n <tr>\n <td>\n Providing you with marketing content (tailored or not), using the communication channel of your choice (e.g. e-mail, SMS/MMS, \n telephone) concerning our own products and services, as well as products and services prepared together with counterparties of \n Benefit Systems, which are offered to our users and customers as additional benefits (e.g. dietary, coaching, educational and \n development services) or products and services of third parties, including companies from the Benefit Systems Group. \n <a href=\"https://document.benefitsystems.pl/temp/fileadmin/benefitsystems/rodo/klienci-lista-podmiotow-20180220.pdf\">\n You can find a list of third parties here.\n </a>.\n </td>\n <td>\n Our legitimate interest (Article 6(1)(f) of the GDPR) connected with presenting you with marketing content, including content \n tailored to you on the basis of profiling, in connection with your consent to the use for this purpose of the communication channel of your choice.\n </td>\n </tr>\n <tr>\n <td>\n Providing you with marketing content as part of a business relationship concerning our own products and services, as well as \n products and services prepared together with counterparties of Benefit Systems, which are offered to you as additional benefits \n (e.g. dietary, coaching, educational and development services) or products and services of third parties, including companies from \n the Benefit Systems Group. <a href=\"https://document.benefitsystems.pl/temp/fileadmin/benefitsystems/rodo/klienci-lista-podmiotow-20180220.pdf\">\n You can find a list of third parties here.\n </a>.\n </td>\n <td>\n Your consent (Article 6(1)(a) of the GDPR) our legitimate interest (Article 6(1)(f) of the GDPR) connected with presenting you with \n marketing content, including content tailored to you on the basis of profiling, in connection with your consent to the use for this \n purpose of the communication channel of your choice (depending on the information provided at the consent gathering stage) \n </td>\n </tr>\n <tr>\n <td>\n Conducting analytics, marketing statistics and surveys of service satisfaction and profiling, i.e. using data about your interests \n in order to provide you with tailored offers and content\n </td>\n <td>\n Our legitimate interest (Article 6(1)(f) of the GDPR) connected with evaluating the efficiency of marketing activities, improving \n the quality of our user service, and improving our products and services. Your explicit consent relating to special categories of \n personal data (Article 9(2)(a) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Performing a contract and conducting cooperation with counterparties, customers and partners\n </td>\n <td>\n When you are a party to a contract with Benefit Systems, we process your data as this is necessary for the performance of the \n contract (Article 6(1)(b) of GDPR);\n <br>\n When you are a representative or a contact person of our counterparty, we act on the basis of our legitimate interest consisting \n in the ability to correctly enter into and perform the contract and cooperate with our counterparty (Article 6(1)(f) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Handling a matter you have raised, including answering a question you have asked or examining a complaint you have submitted.\n </td>\n <td>\n Our legitimate interest (Article 6(1)(f) of the GDPR) connected with handling inquiries or complaints addressed to us and ensuring \n the highest quality of service;\n <br>\n Fulfilment of the legal obligation (Article 6(1)(c) of the GDPR) imposed on us by law (e.g. where the matter you have referred to \n us constitutes a request to exercise your rights under the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Implementation of legal obligations, particularly those arising from tax and accounting laws\n </td>\n <td>\n Applicable law (Article 6(1)(c) of the GDPR);\n </td>\n </tr>\n <tr>\n <td>\n Exercising, establishing or defending legal claims\n </td>\n <td>\n Our legitimate interest consisting in the ability to establish or defend a legal claim (Article 6(1)(f) GDPR or Article 9(2)(f) GDPR in case of special categories of personal data)\n </td>\n </tr>\n </tbody>\n </table>\n "
      },
      {
        "heading": "How long will your personal data be stored",
        "link": "personal-data-3",
        "content": "We store your data for a period necessary to achieve the processing purposes outlined above in the section \n <a href=\"#personal-data-2\">How do we process your personal data?</a>. We will delete the data when they are no longer needed for the \n above purposes. We store your data in particular:\n <ol>\n <li>\n To perform the contract and provide services until the contract has been performed or the service provision has ended, and subsequently \n for a period necessary for effective investigation or defence against claims, which is usually 3 or 6 years, but may be shorter or longer \n in certain situations provided for by law;\n </li>\n <li>\n When law imposes certain obligations on us, in particular tax and accounting obligations, we will process the data necessary for the \n performance of those obligations for the period required by law;\n </li>\n <li>\n When we process data on the basis of your consent, we will process them no longer than until you withdraw your consent;\n </li>\n <li>\n When we process data on the basis of a legitimate interest, we will process them no longer than until the objection is effectively \n raised, unless the data are no longer necessary for the performance of our legitimate interests.\n </li>\n </ol>\n "
      },
      {
        "heading": "Recruitment",
        "link": "recruitment",
        "content": "Information on our processing of personal data of job applicants is available at:\n <br>\n <br>\n <a href=\"https://benefitsystems.pl/o-nas/kariera/obowiazek-informacyjny-dla-kandydata/\">\n https://benefitsystems.pl/o-nas/kariera/obowiazek-informacyjny-dla-kandydata\n </a>\n "
      },
      {
        "heading": "Marketing",
        "link": "marketing",
        "content": "<b>General information</b>\n <br>\n <br>\n The way in which we process personal data for marketing purposes depends on the type of relationship between us (e.g. whether you have \n signed up on our website or mobile application, whether you are our customer or counterparty) and the consents you have given us.\n <br>\n <br>\n Our marketing activities may include displaying advertisements to you on websites or applications, presenting offers or advertisements \n via a communication channel such as e-mail or telephone (if you have authorised us to deliver marketing content to you via the \n communication channel of your choice, e.g. e-mail, SMS/MMS, telephone, push notifications), traditional marketing mailings, conducting \n analyses and statistics for marketing purposes and conducting service satisfaction surveys, including by contacting you by means of the \n communication channel of your choice. We can also perform profiling for marketing purposes.\n <br>\n <br>\n Tailored marketing\n <br>\n <br>\n We may process your personal data for marketing purposes, including for profiling, in the following cases:\n <ol>\n <li>\n <span>If you consent to the storage of cookies or similar technologies on your device, we may use the information collected by \n means of those technologies to provide you with advertisements or offers tailored to your potential interests identified on the basis \n of the content you view and your activity. For example, if you browse pages related to MultiSport packages, we will be able to display \n you an advertisement for MultiSport or our other services on other websites and in applications;\n </span>\n </li>\n <li>\n <span>\n <b>If you are a registered user of our website or application</b> and you log in to your account, we will be able to associate \n information on the content you viewed with you, and use it for profiling purposes to better adjust our marketing communication and offer for you;\n </span>\n </li>\n <li>\n <span>\n <b>If you have authorised us to deliver marketing content</b> to you via the communication channel of your choice\n </span>\n </li>\n <li>\n <span>\n <b>If we concluded a contract or cooperate</b>\n </span>\n </li>\n <li>\n <span>\n <b>if you agree to our use of information about the location of your device (e.g. smartphone)</b>, we will be able to display to you \n advertisements or offers relevant to your location. For example, we will be able to show you an invitation to an event held to \n celebrate the opening of our new fitness club nearby;\n </span>\n </li>\n <li>\n <span>\n <b>To conduct analyses and statistics</b> for our marketing needs and to test your satisfaction with the services we offer by \n contacting you via the communication channel of your choice.\n </span>\n </li>\n </ol>\n <br>\n <br>\n We can also present you with unprofiled advertisements and offers.\n <br>\n <br>\n <b>What is profiling for marketing purposes?</b>\n <br>\n <br>\n Our processing of your personal data for direct marketing purposes involves profiling.\n <br>\n <br>\n Profiling is the use of automatic processing of your data to draw conclusions about your potential interests and preferences. By \n profiling, we can match products, offers and advertisements to you in the best way possible. As part of profiling, we can also combine \n information that you leave us when using our different products and services, such as information that you leave when visiting our website \n or application, using the MultiSport or MultiLife Programme, the Cafeteria, or the services of our Fitness Club.\n <br>\n <br>\n For profiling, we use tools provided by specialised third parties. See our <a href=\"/en/cookies-policy\">“Cookies Policy”</a> for more information about our partners \n and the possibility of adjusting your advertising preferences. We seek to ensure that profiling brings you clear benefits: offers, \n promotions and advertisements that you may find interesting. In this way, we want to ensure we do not present you with content that might \n be inappropriate or unattractive for you. Example: if we determine that you are a woman and as part of the MultiSport Programme you \n regularly attend dance classes in a particular location, this will give us a signal that you may be interested in new dance classes in \n your favourite location, but you are probably not interested in martial art classes in another, distant city.\n <br>\n <br>\n <b>Our legitimate interest and your interests, rights and freedoms</b>\n <br>\n <br>\n We process your personal data for marketing purposes, including profiling, based on our legitimate interest. For this reason, we have \n assessed whether your interests, rights and freedoms (e.g. the right to privacy) outweigh our interests. This assessment has shown that \n we can process your personal data in the indicated manner, because:\n <br>\n <br>\n <ol>\n <li>\n We process your personal data for marketing purposes only when we find that you can reasonably expect that processing (e.g. you are a \n user of the MultiSport card or Fitness Club subscription, you sign up on our website or in our application, and consent to receiving \n marketing e-mails from us);\n </li>\n <li>\n We will send you marketing communications via e-mail, SMS/MMS or phone calls only with your consent;\n </li>\n <li>\n We will send you marketing communications about products or services of third parties not affiliated with Benefit Systems via e-mail, \n SMS/MMS or phone calls only if you separately consent to those communications;\n </li>\n <li>\n We enable you to easily object to the processing of your personal data for direct marketing purposes, and we inform you about this right;\n </li>\n <li>\n Our profiling for marketing purposes does not excessively interfere with your privacy. We focus on what products or services available \n on our offer you may find interesting. We do not want to provide you with content that you might find unattractive. Based on our \n profiling, we do not take any decisions against you with adverse legal effects (e.g. refusal to conclude a contract) or that might \n significantly affect you in a similar way.\n </li>\n <li>\n We use technical and organisational measures that adequately protect your personal data.\n </li>\n </ol>\n "
      },
      {
        "heading": "Social media",
        "link": "social-media",
        "content": "You can find us on social media such as Facebook, Instagram and LinkedIn among others. Each social media platform informs you about the way in which it processes your data during registration, under their terms and conditions or privacy policies. We do not have access to all the information about you in the same capacity as the aforementioned platforms. However, if you have an account on a social media platform and observe our profiles (such as MultiLife, MultiSport, Zdrofit, Fabryka Formy, Benefit Systems) or engage with us ( e.g. leaving likes, hearts, comments, or texting us directly via the communicator of a given service), then we can see the information about you that you have provided on a given social media platform when contacting us, or that the platform provides us with, e.g. in relation to displaying advertisements or our profile (depending on your privacy settings on that platform).<br>\n<br>\n<b>Our pages on social media platforms</b>\n <br>\n <br>\n As mentioned above, the social media platform will be the administrator of your personal data, which it processes in accordance with the information provided to you during registration, for example on:<ol><li> LinkedIn (Privacy Policy: https://www.linkedin.com/legal/privacy-policy#others; Page Insights Joint Controller Addendum: https://www.linkedin.com/legal/l/page-joint-controller-addendum)</li><li>Meta (Facebook; Instagram, Threads) (Privacy Center Facebook: <a href=\"https://www.facebook.com/about/privacy\" target=\"_blank\">\n www.facebook.com/about/privacy</a>, Data Policy Instagram: <a href=\"https://help.instagram.com/155833707900388\" target=\"_blank\">\n https://help.instagram.com/155833707900388</a>).</li></ol>Only when you interact with our profile in the given service can we process your data as its administrator, which we inform you about in the information clauses posted on individual social media platforms. Additionally, we may act as so-called joint controllers with certain social media platforms. For example, with regard to data processing for statistics purposes as part of our Facebook and Instagram pages, we and Meta Platforms Ireland Limited, Block J, Serpentine Avenue, Dublin 4, Ireland act as joint controllers of your data. The joint controller arrangements can be found at <a href=\"https://www.facebook.com/legal/controller_addendum\">www.facebook.com/legal/controller_addendum</a>. When we make use of Meta products, we do it in compliance with their Terms and Conditions. You can find more information about website statistics at: <a href=\"https://www.facebook.com/legal/terms/information_about_page_insights_data\">www.facebook.com/legal/terms/information_about_page_insights_data</a>.If you would like detailed information about data processing on social media platforms, you can also contact us. You will find our contact details above in the section <a href=\"#contact\">How to contact us</a>.<br>\n<br>\n<b>Social media plugins and codes</b><br>\n<br>\nRemember, if you sign up and log in using external authentication services offered by Facebook, Google, Apple or others, we will receive your personal data, notably your name, surname/ username, profile photo, ID, and authorisation details for a given platform. Depending on your privacy settings in the indicated external platform, we can also receive other data. Before using this service, read the terms and conditions for using the data by the external platform.<br>\n<br>\nIn addition, we place social media buttons and codes on our websites and in our applications. When you are redirected to a given social media portal by clicking one of those buttons, you can, for example, like or start following our website. Your activity and personal data are then also processed by the entity operating the portal and are used by that entity for its own purposes, e.g. for marketing. Your activity on pages containing codes and your personal data are collected by entities running social media portals, in particular for statistical purposes and to check whether you are a logged user of this portal, and to enable the provision of services (e.g. logging in by means of your social media account). The data are also further processed for other purposes specified by those entities. This applies to all users of our websites, regardless of whether they are registered users of those social media portals.<br>\n<br>\nWe process and enable social media portals to access specified data based on our legitimate interest (Article 6(1)(f) of the GDPR). This consists in enabling you to share your content of interest on social media, facilitating your logging in, and promoting our business, services and products. Detailed information on the processing of your personal data and the method of exercising your rights related to data processing by social medial portals are described in the privacy policies of respective portals. Please read them."
      },
      {
        "heading": "Is providing data compulsory",
        "link": "providing-data",
        "content": "As a rule, providing personal data is not compulsory, but may be necessary for you to use the services provided by Benefit \n Systems, e.g. to enter into an agreement with us, to participate in our competitions or to have a matter your raise examined. \n Therefore, your failure to provide your data may in some instances make it impossible for us to provide services or undertake other \n actions. Our forms used to collect data clearly indicate the data the provision of which is necessary.\n "
      },
      {
        "heading": "Who do we transfer your data to",
        "link": "disclose-data",
        "content": "Your personal data may be disclosed to the following entities: entities from \n <a href=\"https://benefitsystems.pl/dla-inwestora/lad-korporacyjny/lista-spolek-grupy-kapitalowej-benefit-systems/\" target=\"_blank\">\n Benefit Systems Group companies</a> hosting and maintenance service providers for our websites and applications, ICT and IT support and \n security service providers, data storage and destruction service providers, providers of services that are in addition to the services \n we provide you with, our Partners (sports and recreation, entertainment, and cultural facilities, hotels, offices and tourist \n intermediaries), entities that have enabled you to use the MultiSport Programme, MultiLife, Cafeteria or other services (usually your \n employer or the employer of the person who reported you to the MultiSport or MultiLife Programme), card printers, social network \n operators, payment operators, firms supporting us in debt collection, entities providing services related to serving our clients, \n and to other stakeholders (e.g. couriers) and to those entities which support our marketing activities, as well as to legal advisors \n and auditors.\n <br>\n <br>\n Your data may also be disclosed to public authorities in cases provided for by law.\n "
      },
      {
        "heading": "Are your data transferred outside the European Economic Area",
        "link": "data-transfer",
        "content": "As a rule, your personal data are not transferred outside the European Economic Area (EEA). Some of the data recipients (such es technological solution providers) may process them in third countries. We make every effort for the provision of data to these providers to be lawful and that all relevant safeguards are in place. If the European Commission has not issued a decision confirming that a given third country ensures an adequate level of personal data protection, we ensure that data transfers are carried out on the basis of other legal protection measures, e.g. based on standard contractual clauses or codes of conduct. You can contact us to obtain copies of the implemented security measures. You can find contact details above in section <a href=\"#contact\">How to contact us</a>."
      },
      {
        "heading": "What are your rights",
        "link": "data-rights",
        "content": "\n You have the right to:\n <ol>\n <li>\n <span>\n <b>Access to your personal data</b>, obtain information from us about their processing, as well as receive a copy of your data from us;\n </span>\n </li>\n <li>\n <span>\n <b>Update your personal data</b> or request their rectification if they are incorrect;\n </span>\n </li>\n <li>\n <span>\n <b>Withdraw your consent to personal data processing</b> at any time. This will not affect the lawfulness of our processing on \n the basis of the consent prior to its withdrawal;\n </span>\n </li>\n <li>\n <span>\n <b>Object to the processing of your data</b> when the processing is based on a legitimate interest, and the objection is justified \n by your particular situation;\n </span>\n </li>\n <li>\n <span>\n <b>Object to the processing of your personal data for direct marketing purposes, including profiling;</b>\n </span>\n </li>\n <li>\n <span>\n <b>Request restriction of processing of your personal data</b> if \n <br>\n (1) you question the accuracy of your data (for a period enabling us to verify the accuracy of the data); \n <br>\n (2) the processing is unlawful and you oppose the erasure of your personal data and request restriction of their use instead; \n <br>\n (3) we no longer need your personal data for our purposes, but these data are needed by you for the establishment, exercise or defence of legal claims, or \n <br>\n (4) you have objected to the processing of your data – until the objection is found effective;\n </span>\n </li>\n <li>\n <span>\n <b>Personal data portability</b> – with respect to the processing of your data based on your consent or an agreement, you have \n the right to receive your personal data from us in a commonly used and machine-readable computer format. You can also request \n that we transfer your data to another data controller, but we will only do so if this transfer is technically feasible;\n </span>\n </li>\n <li>\n <span>\n <b>Request erasure of your personal data</b> – you may request us to erase your data in the following cases: \n <br>\n (1) if your data are no longer necessary for the purposes for which they are processed; \n <br>\n (2) you have withdrawn the consent on which the processing is based, and there is no other basis for processing; \n <br>\n (3) you have effectively objected to the processing; \n <br>\n (4) your personal data have been unlawfully processed; \n <br>\n (5) your data must be erased because we are required to do so by law.\n </span>\n </li>\n </ol>\n <br>\n <br>\n To exercise the above rights, please contact us or our data protection officer. You can find contact details above in section \n <a href=\"#contact\">How to contact us</a>\n <br>\n <br>\n Your request will be handled within one month of its receipt. When we need more time, we will inform you about the prolonged time for \n considering your request and about the reasons for the prolongation. If your request is manifestly unjustified or excessive, we may \n refuse to take the requested actions.\n <br>\n <br>\n <b>You also have the right lodge a complaint with a supervisory authority</b> competent for data protection in the EU Member State of your \n habitual residence, place of work or place of the alleged infringement. In Poland, the supervisory authority is the President of the \n Personal Data Protection Office. To learn more about lodging complaints with the President of the Personal Data Protection Office, \n please visit the following page: <a href=\"https://uodo.gov.pl/pl/83/155\" target=\"_blank\">https://uodo.gov.pl/pl/83/155</a>\n "
      },
      {
        "heading": "Amendments to the Privacy Policy",
        "link": "amendments",
        "content": "We will regularly review and update this Policy in connection with amendments to applicable laws and any new measures we may \n take to improve the security of your personal data."
      }
    ]
  },
  "data": {
    "header": "Spis treści",
    "subheader": "Jeżeli chcesz przejść do wybranej sekcji, kliknij w link poniżej:",
    "list": [
      {
        "heading": "Administrator danych",
        "link": "dataadmi",
        "content": "Administratorem Twoich danych osobowych jest Benefit Systems S.A. z siedzibą w Warszawie (dalej „my” lub „Benefit Systems”), Pl. Europejski 2, 00-844 Warszawa. Możesz się z nami skontaktować poprzez adres e-mail: daneosobowe@benefitsystems.pl lub pisemnie na adres: Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „Dane osobowe”."
      },
      {
        "heading": "Inspektor ochrony danych",
        "link": "datains",
        "content": "Wyznaczyliśmy inspektora ochrony danych, z którym można się skontaktować we wszystkich sprawach związanych z przetwarzaniem danych osobowych oraz wykonywaniem praw przysługujących zgodnie z RODO. Z inspektorem można się skontaktować poprzez e-mail: iod@benefitsystems.pl lub pisemnie na adres: Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „IOD”."
      },
      {
        "heading": "Jakie dane na Twój temat przetwarzamy i skąd je mamy?",
        "link": "datakinds",
        "content": "Zasadniczo Twoje dane osobowe pozyskujemy bezpośrednio od Ciebie. Przetwarzamy dane osobowe zawarte w przesłanym przez Ciebie zgłoszeniu rekrutacyjnym, dane podane przez Ciebie i inne dane zebrane w trakcie procesu rekrutacyjnego (tj. w trakcie spotkań rekrutacyjnych, testów kompetencyjnych). Możemy także przetwarzać dane osobowe uzyskane od agencji rekrutacyjnej, która Cię reprezentuje lub przekazane nam przez Twoich pracodawców (gdy wyrazisz zgodę na weryfikację referencji) oraz dane zawarte na publicznie dostępnych stronach internetowych o charakterze zawodowo - biznesowym np. Twoim profilu na Linkedin."
      },
      {
        "heading": "W jakim celu, na jakiej podstawie prawnej oraz przez jaki okres przetwarzamy Twoje dane osobowe?",
        "link": "datapurpose",
        "content": "<ol>\n<li> Jeżeli zatrudnienie ma nastąpić na podstawie umowy o pracę: Twoje dane osobowe wskazane w Kodeksie pracy lub w innych ustawach szczegółowych (według wymogów ogłoszenia) są przetwarzane w oparciu o przepisy prawa lub w celu podjęcia działań na Twoje żądanie przed zawarciem umowy (np. termin rozpoczęcia pracy, wynagrodzenie) (podstawa prawna – art. 6 ust. 1 lit. b i c RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li></li>Jeżeli zatrudnienie ma nastąpić na podstawie umowy cywilnej: Twoje dane osobowe, takie jak dane identyfikacyjne, dane kontaktowe, wykształcenie, kwalifikacje zawodowe i historia zatrudnienia, termin rozpoczęcia pracy, wynagrodzenie są przetwarzane w celu podjęcia działań na Twoje żądanie przed zawarciem umowy (podstawa prawna – art. 6 ust. 1 lit. b RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.<li>Twój adres email przetwarzamy na podstawie naszego uzasadnionego interesu polegającego na prowadzeniu i zarządzaniu rekrutacjami w systemie rekrutacyjnym. Z tego powodu, jeżeli decydujesz się do nas zaaplikować, wymagamy od Ciebie podania adresu email (podstawa prawna – art. 6 ust. 1 lit. f RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Dane dotyczące weryfikacji Twoich oświadczeń zawartych w zgłoszeniu i w trakcie procesu rekrutacyjnego, w szczególności Twoich kompetencji, w tym dane pozyskane w wyniku przeprowadzenia testów kompetencji (np. informacje o Twojej wiedzy i umiejętnościach), zebrane przez nas lub współpracującą z nami agencję rekrutacyjną, zebrane z Linkedin lub innych publicznie dostępnych stron internetowych o charakterze zawodowo – biznesowym przetwarzamy, w celu realizacji naszych uzasadnionych interesów (podstawa prawna – art. 6 ust. 1 lit. f RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Dane zawarte w referencjach od poprzednich pracodawców lub uzyskane podczas naszych rozmów z pracodawcami (np. dane dotyczące Twoich umiejętności), w oparciu o Twoją zgodę (podstawa prawna – art. 6 ust. 1 lit. a RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia rozmowy referencyjnej z osobą, która ich udzieliła. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 30 dni od otrzymania referencji.</li><li>Dodatkowe dane, które zdecydujesz się nam przekazać dobrowolnie, np. wizerunek czy informacje o zainteresowaniach będziemy przetwarzać na podstawie Twojej zgody (podstawa prawna – art. 6 ust. 1 lit. a RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych, w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>W przypadku konieczności powtórzenia rekrutacji będziemy przetwarzać, w tym celu Twoje dane zebrane w związku z rekrutacją na podstawie uzasadnionego interesu (podstawa prawna – art. 6 ust. 1 lit. f RODO). Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>W przypadku, gdy w procesie Twojej rekrutacji udział bierze agencja rekrutacyjna przetwarzamy Twoje dane identyfikacyjne oraz informacje o Twoich oczekiwaniach finansowych lub wynagrodzeniu na podstawie uzasadnionego interesu w celu wykonania umowy z tą agencją (podstawa prawna – art. 6 ust. 1 lit. f RODO). Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Przyszłe rekrutacje na stanowiska w Spółce odpowiadające Twoim kwalifikacjom na podstawie Twojej zgody (podstawa prawna – art. 6 ust. 1 lit. a RODO). Jeżeli brałeś lub weźmiesz udział w kilku rekrutacjach i wyrazisz zgodę, abyśmy zgromadzone dane wykorzystali również na potrzeby przyszłych rekrutacji, wówczas – prowadząc taką przyszłą rekrutację, możemy wykorzystać wszystkie dane zebrane o Tobie – o ile nie upłynął okres przetwarzania danych na podstawie wyrażonej zgody. Twoje dane będą przetwarzane w tym celu przez okres 24 miesięcy od wyrażenia zgody.</li><li>W sytuacji, gdy podmioty należące do grupy kapitałowej Benefit Systems (lista podmiotów: www.benefitsystems.pl/o-nas/lista-spolek-grupy-kapitalowej-benefit-systems/) prowadzą podobny proces rekrutacyjny do tego realizowanego w naszej spółce możemy przekazać im dane kandydatów z naszej bazy danych (podstawa prawna – art. 6 ust. 1 lit. a RODO). Możemy wykorzystać w tym celu wszystkie dane zebrane o Tobie – o ile nie upłynął okres przetwarzania danych na podstawie wyrażonej zgody. Twoje dane będą przetwarzane w tym celu przez okres 24 miesięcy od wyrażenia zgody. Podmioty, którym dane zostaną udostępnione staną się ich odrębnymi administratorami i będą przetwarzać Twoje dane według własnych zasad.</li><li>Wyjątkowo, w przypadku ewentualnych nieporozumień miedzy Tobą a Spółką, w celu dochodzenia roszczeń i obrony przed roszczeniami, na podstawie naszego uzasadnionego interesu (podstawa prawna – art. 6 ust. 1 lit. f RODO). Twoje dane będą przetwarzane zasadniczo przez okres 3 lat od zakończenia rekrutacji, a dłużej, jeśli wynika to z przepisów prawa.</li></ol>\nPodanie danych osobowych wskazanych w Kodeksie pracy lub innych przepisach prawa (jeżeli zostały wskazane w ogłoszeniu) jest obowiązkowe, żeby wziąć udział w danej rekrutacji. Podobnie podanie danych niezbędnych do podjęcia działań na Twoje żądanie przed zawarciem umowy oraz niezbędnych w naszym uzasadnionym interesie. Podanie pozostałych danych jest dobrowolne. Zasadniczo prosimy o nieprzekazywanie nam danych wrażliwych, o których mowa w art. 9 ust. 1 RODO, w tym danych o stanie zdrowia. Jeżeli jesteś osobą niepełnosprawną i uznasz, że poinformowanie nas o tym jest istotne dla procesu rekrutacyjnego, będziemy przetwarzać te dane w oparciu o przepisy prawa. W pozostałych sytuacjach, jeżeli decydujesz się przekazać nam dane wrażliwe, np. ze względu na Twoją szczególną sytuację, będziemy mogli je przetwarzać jedynie, gdy udzielisz wyraźnej zgody na przetwarzanie przez nas takich danych wrażliwych. Przekazanie takich danych jest dobrowolne."
      },
      {
        "heading": "Odbiorcy danych",
        "link": "datareceive",
        "content": "Twoje dane osobowe mogą zostać przekazane następującym podmiotom: podmiotom z grupy Benefit Systems (lista podmiotów: www.benefitsystems.pl/o-nas/lista-spolek-grupy-kapitalowej-benefit-systems/), podmiotom świadczącym usługi hostingu i utrzymania naszych serwisów internetowych i aplikacji, podmiotom świadczącym usługi teleinformatyczne i usługi w zakresie wsparcia i bezpieczeństwa IT, podmiotom świadczącym usługi przechowywania i niszczenia nośników danych, agencjom rekrutacyjnym, osobom udzielającym referencji, podmiotom świadczącym usługi związane z obsługą naszych klientów i innych interesantów (np. kurierom), doradcom prawnym i podmiotom prowadzącym audyty. Twoje dane mogą zostać przekazane także organom publicznym w przypadkach przewidzianych przez prawo."
      },
      {
        "heading": "Przekazywanie danych poza EOG",
        "link": "datasend",
        "content": "Co do zasady Twoje dane osobowe nie są przekazywane poza Europejski Obszar Gospodarczy (EOG). Niektóre podmioty, którym możemy przekazać dane mają siedzibę poza terytorium EOG. Dokładamy należytych starań, aby przekazywanie danych było zgodne z prawem i wdrożone zostały odpowiednie zabezpieczenia. Obejmuje to w szczególności stosowanie standardowych klauzul umownych zatwierdzonych przez Komisję. Możesz się z nami skontaktować w celu uzyskania kopii przyjętych środków ochrony. Dane kontaktowe znajdziesz w sekcji „administrator danych” lub „inspektor ochrony danych” powyżej."
      },
      {
        "heading": "Zautomatyzowane podejmowanie decyzji",
        "link": "dataauto",
        "content": "Nie podejmujemy wobec Ciebie decyzji opierających się wyłącznie na zautomatyzowanym przetwarzaniu informacji o Tobie, które wywoływałyby wobec Ciebie skutki prawne lub w podobny sposób istotnie na Ciebie wpływały."
      },
      {
        "heading": "Twoje prawa związane z przetwarzaniem danych osobowych",
        "link": "dataright",
        "content": "żądania dostępu do danych, prawo żądania sprostowania danych, prawo żądania usunięcia danych, prawo żądania ograniczenia przetwarzania, prawo wniesienia sprzeciwu wobec przetwarzania, prawo żądania przeniesienia podanych danych, prawo do wycofania zgody na przetwarzanie danych osobowych w dowolnym momencie. Aby skorzystać z powyższych praw skontaktuj się z nami lub z naszym inspektorem ochrony danych. Dane kontaktowe znajdziesz powyżej. Masz także prawo do wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych."
      }
    ]
  },
  "surveillance": {
    "header": "Table of contents",
    "subheader": "If you want to go to the selected section, click on the link below:",
    "list": [
      {
        "heading": "Who is the controller of your personal data? ",
        "link": "admin",
        "content": "The controller of your personal data is Benefit Systems (Benefit Systems S.A., with its registered office in Warsaw, Pl. Europejski 2, 00-844 Warsaw, hereinafter referred to as 'Benefit Systems' or 'we'). This means Benefit Systems determines the purposes and methods of processing your personal data, i.e., why and how your data will be used.  "
      },
      {
        "heading": "How to contact us ",
        "link": "contact",
        "content": "You can contact Benefit Systems in the following ways:\n <ol>\n <li>By email: daneosobowe@fitness.benefitsystems.pl  </li>\n <li>In writing: Pl. Europejski 2, 00-844 Warsaw, with the annotation “Personal Data” </li>\n <li>Via contact form: <a href=\"https://www.benefitsystems.pl/pomoc-i-obsluga/rodo/\">https://www.benefitsystems.pl/pomoc-i-obsluga/rodo/.<\/a>  </li>\n</ol>\n"
      },
      {
        "heading": "Have we appointed a Data Protection Officer? ",
        "link": "inspector",
        "content": "Yes, we have appointed a Data Protection Officer. You can contact them as follows: :\n <ol>\n <li>By email: iod@benefitsystems.pl </li>\n <li>In writing: Pl. Europejski 2, 00-844 Warsaw, with the annotation “IOD” </li>\n </ol>\n"
      },
      {
        "heading": "What is the scope of video monitoring? ",
        "link": "area",
        "content": "Areas and premises under video monitoring are appropriately marked (e.g., with a camera symbol). As part of the monitoring system, we process data of individuals within the range of our installed cameras. These data may include your image and other information visible in the recordings, such as unique features or specific behaviors. <br><br> Video monitoring only captures images, not sound. Monitoring does not include restrooms or locker rooms. "
      },
      {
        "heading": "Why and on what basis do we process your personal data? ",
        "link": "purpose",
        "content": "We process your personal data via video monitoring to fulfill the following purposes: \n <ol>\n <li>Legitimate interests of Benefit Systems (legal basis: Article 6(1)(f) GDPR), including:  <br>\n <br>a.\n Ensuring the safety of individuals on the premises. <br>b.\n Protecting the property of Benefit Systems and individuals on the premises.  <br>c.\n Establishing, pursuing, or defending claims when necessary.  <br>\n <br> This ensures everyone on our premises feels safe, their property is secure, and we can maintain high standards of service. If theft, property damage, or a similar incident occurs, we may use video recordings to assert our rights or secure evidence for authorities. </li>\n <li>\nCompliance with legal obligations (legal basis: Article 6(1)(c) GDPR), including:  <br>\n <br>a.\n Providing data to authorized state authorities upon lawful and documented requests.  <br>b.\n Fulfilling GDPR-related rights such as granting access to recordings upon request. <br><br> For example, if law enforcement or other authorized authorities request specific recordings during an investigation, we must comply. Similarly, if you exercise your rights under GDPR (e.g., access to your data), we may need to secure recordings for you.  </li>\n  </ol>\n "
      },
      {
        "heading": "How long do we keep your personal data? ",
        "link": "time",
        "content": "Your data is retained only as long as necessary to fulfill the purposes outlined above, but no longer than one month from the date of recording. <br> <br>If recordings serve as evidence in ongoing legal proceedings or Benefit Systems becomes aware they may serve as such, the retention period is extended until the proceedings are legally concluded."
      },
      {
        "heading": "Who can access your personal data?",
        "link": "who",
        "content": "Recipients of your personal data may include: <br><br>-\n IT service providers maintaining our video monitoring systems.  <br>-\n Legal, tax, and audit advisors. <br>-\n Security agencies and public authorities in legally mandated cases. "
      },
      {
        "heading": "Your rights regarding personal data processing",
        "link": "laws",
        "content": "You have the following rights: <br>\n <br> &#8226;\n Right to object to data processing based on legitimate interests, due to your specific situation. <br> &#8226;\n Right of access to your personal data. <br> &#8226;\n Right to request deletion of your data. <br> &#8226;\n Right to correct inaccuracies in your data. <br> &#8226;\n Right to request restriction of data processing.  <br><br> To exercise these rights, contact us or our Data Protection Officer using the contact details provided earlier.  <br><br> You also have the right to lodge a complaint with the supervisory authority for data protection, which in Poland is: President of the Personal Data Protection Office ul. Stawki 2, 00-193 Warsaw "
      },
      {
        "heading": "Are decisions made based solely on automated processing? ",
        "link": "auto",
        "content": "We do not make decisions based solely on automated processing that could have legal or similarly significant effects on you. "
      },
      {
        "heading": "Is providing your personal data mandatory? ",
        "link": "obligations",
        "content": "Providing your data is not mandatory. However, being on premises under video monitoring means your data will be captured per the conditions described in this notice.  "
      },
      {
        "heading": "Is your data transferred outside the EEA?",
        "link": "yourdata",
        "content": "Your data is not typically transferred outside the European Economic Area (EEA). If it is, appropriate legal safeguards, such as standard contractual clauses approved by the European Commission, are in place."
      },
      {
        "heading": "Additional information",
        "link": "additionalInfo",
        "content": "For more details on how Benefit Systems processes personal data and your rights, please visit: <a href=\"https://www.benefitsystems.pl/en/privacy-policy\">https://www.benefitsystems.pl/en/privacy-policy<\/a> "
      }
    ]
  }
}
